import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createMetal } from "../../helpers/http_metals_requests";

const priceKindOptions = [
    { value: 1, label: "Usa cotação de ouro 18K" },
    { value: 2, label: "Usa cotação de ouro 10K" },
    { value: 3, label: "Usa cotação de prata" },
];

export default function MetalNew() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const formFieldList = [
        {
            title: "Cadastro de Metal",
            fields: [
                { name: "name", label: "Nome", type: "text", required: true },
                { name: "color", label: "Cor", type: "text", helpertext: "Ex.: #D4AF37" },
                { name: "price_kind", label: "Cotação", type: "select", required: true, options: priceKindOptions },
                { name: "position", label: "Ordem", type: "number", required: true },
            ],
        },
    ];

    const handleSubmit = (data) => {
        createMetal(
            {
                name: data.name,
                color: data.color || "#C8A459",
                price_kind: Number(data.price_kind) || 1,
                position: Number(data.position) || 0,
            },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getMetals"] });
                navigate("/configuracao-metais");
            }
        );
    };

    return (
        <DynamicFormPage
            title="Metais - Cadastro"
            onSubmit={handleSubmit}
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
